import { render } from "./upload-image.vue?vue&type=template&id=0f0dd4bc&scoped=true"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"

import "./upload-image.vue?vue&type=style&index=0&id=0f0dd4bc&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0dd4bc"]])

export default __exports__